/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { PlusOutlined } from '@ant-design/icons';
import { useState } from 'react';

import { ContentContainer } from '@/components/ContentContainer';
import { GuardedButton } from '@/components/GuardedButton';
import { QueryWrapper } from '@/components/QueryWrapper';
import { usePaginatedNodeGroupsQuery } from '@/hooks/query/usePaginatedNodeGroupsQuery';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { FleetManagementHeader } from '@/pages/FleetManagement/FleetManagementHeader';
import { NewFleetWizard } from '@/pages/FleetManagement/NewFleetWizard';
import { NodeGroupsTable } from '@/pages/FleetManagement/NodeGroupsTable';
import { Container } from '@/primitives/Container';
import { Space } from '@/primitives/Space';

export function FleetManagementPage() {
  const [newFleetOpen, setNewFleetOpen] = useState(false);
  const nodeGroupsQuery = usePaginatedNodeGroupsQuery({ type: 'queryParams' });
  const { t } = useMimicTranslation('fleets');

  return (
    <ContentContainer width="100%">
      <Container>
        <Space dir="vertical" size="md" width="100%">
          <FleetManagementHeader
            fleetCount={nodeGroupsQuery.data?.meta.page.totalItems ?? 0}
            fleetIsLoading={nodeGroupsQuery.isLoading}
          />
          <QueryWrapper queryResult={nodeGroupsQuery}>
            {(nodeGroupsData) => (
              <NodeGroupsTable
                nodeGroupsData={nodeGroupsData}
                onParamsChange={nodeGroupsQuery.updateQueryParams}
                primaryAction={
                  <GuardedButton
                    requiredRole="admin"
                    type="primary"
                    dataTestId="new-fleet"
                    onClick={() => setNewFleetOpen(true)}
                  >
                    <PlusOutlined /> {t('newFleet')}
                  </GuardedButton>
                }
              />
            )}
          </QueryWrapper>
        </Space>
      </Container>
      <NewFleetWizard open={newFleetOpen} onClose={() => setNewFleetOpen(false)} />
    </ContentContainer>
  );
}
